import React from 'react';
import OktaSignInWidget from "./OktaSignInWidget";

export default function NonDegradableError() {
  return <OktaSignInWidget nonDegradableError={true} />;
}
